<script setup>
/**
 * "Chat with support" on the rail: token-gated launcher for Tola's own web
 * widget (see useSupportChatWidget).
 */
import { useI18n } from 'vue-i18n';
import { useSupportChatWidget } from 'dashboard/composables/useSupportChatWidget';

const { t } = useI18n();
const { isAvailable, isLoading, toggleSupportChat } = useSupportChatWidget();
</script>

<template>
  <button
    v-if="isAvailable"
    v-tooltip.right="t('RAIL.SUPPORT')"
    type="button"
    :aria-label="t('RAIL.SUPPORT')"
    class="grid size-10 flex-shrink-0 place-items-center rounded-[10px] text-n-rail-text transition-colors duration-200 ease-out outline outline-1 outline-transparent hover:bg-n-rail-hover hover:text-n-rail-text-active focus-visible:outline-2 focus-visible:outline-n-rail-indicator active:scale-[0.98] motion-reduce:transition-none shell:size-[46px]"
    @click="toggleSupportChat"
  >
    <span
      class="size-5 flex-shrink-0"
      :class="
        isLoading
          ? 'i-lucide-loader-circle animate-spin'
          : 'i-ph-chat-circle-dots'
      "
    />
  </button>
</template>
